import { createAsyncThunk } from '@reduxjs/toolkit';
import { getTeamsChannelHistory } from '../../../services/teamsChat';

export const ThunkGetTeamsChatMessages = createAsyncThunk(
  'teamsChat/getTeamsChatMessages',
  async (chatId: number) => getTeamsChannelHistory(chatId).then(r => r.data),
);

export default {};
